import loadable from "@loadable/component";
import { useIsMutating } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import Button from "@krea/customer-features/shared-components/button";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@krea/customer-features/shared-components/dialog";
import Preloader from "@krea/customer-features/shared-components/preloader";
import { Text } from "@krea/customer-features/shared-components/text";
import { useSubmitApplicationAndDeleteDuplicates } from "@krea/customer-features/store/current-loan-application/hooks";
import { SUBMIT_APPLICATION_STORE_KEY } from "@krea/customer-features/store/queryClient";

export const SubmitApplicationAndDeleteDuplicatesModal = () => {
  const { t } = useTranslation();
  const isSubmitting = useIsMutating({
    mutationKey: [SUBMIT_APPLICATION_STORE_KEY],
  });
  const { mutate: submitApplicationAndDeleteDuplicates } =
    useSubmitApplicationAndDeleteDuplicates();

  return (
    <>
      <DialogTitle
        title={t(
          "dash.messages.applicationNotSubmitted.duplicate.submitNewApplication.actionText",
        )}
      />
      <DialogContent>
        <Text>
          {t(
            "dash.messages.applicationNotSubmitted.duplicate.submitNewApplication.description",
          )}
        </Text>
      </DialogContent>
      <DialogActions>
        {isSubmitting ? <Preloader className="text-primary" size="md" /> : null}
        <Button
          onClick={submitApplicationAndDeleteDuplicates}
          disabled={isSubmitting}
        >
          {t(
            "dash.messages.applicationNotSubmitted.duplicate.submitNewApplication.actionText",
          )}
        </Button>
      </DialogActions>
    </>
  );
};
